import { jsx as _jsx } from "react/jsx-runtime";
export const PlusIcon = ({ color = 'currentColor', size = 14, ref, ...props }) => {
    return (_jsx("svg", { width: size, height: size, stroke: color, fill: "none", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props, ref: ref, children: _jsx("path", { d: "M10 10V3M10 10H17M10 10V17M10 10C10 10 6.12419 10 3 10", strokeWidth: "1.6" }) }));
};
//# sourceMappingURL=plus-icon.js.map